export const ErrorFallback = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div>
        <p>エラーが発生しました</p>
      </div>
    </div>
  );
};
